package com.exura.pages.publicplans.orders

import com.exura.features.publicplans.domain.model.AnonymousPublicPlanOrder
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.plus


internal fun calculateOrderStatsDaily(
    orders: List<AnonymousPublicPlanOrder>,
    sortedTargetDates: List<LocalDate>
): List<OrderStats> {
    if (sortedTargetDates.isEmpty()) return emptyList()

    val minTarget = sortedTargetDates.first()
    val maxTarget = sortedTargetDates.last()
    val statsMap = sortedTargetDates.associateWith { OrderStats(date = it) }

    for (order in orders) {
        val accessDate = order.accessedDate.date
        val anchor = order.anchorDate.date
        val durationDays = order.orderDuration

        val startDate: LocalDate
        val endDate: LocalDate

        if (durationDays >= 0) {
            startDate = anchor
            endDate = anchor.plus(DatePeriod(days = durationDays))
        } else {
            startDate = anchor.plus(DatePeriod(days = durationDays)) // plus negative adds negative
            endDate = anchor
        }

        val isAccessRelevant = accessDate in minTarget..maxTarget
        val isOrderOverlap = endDate >= minTarget && startDate <= maxTarget

        if (!isAccessRelevant && !isOrderOverlap) continue

        if (isAccessRelevant) {
            statsMap[accessDate]?.let { it.accessedCount++ }
        }

        if (startDate in minTarget..maxTarget) {
            statsMap[startDate]?.let { it.startedCount++ }
        }

        if (endDate in minTarget..maxTarget) {
            statsMap[endDate]?.let { it.endedCount++ }
        }

        if (isOrderOverlap) {
            var startIndex = sortedTargetDates.binarySearch(startDate)

            if (startIndex < 0) startIndex = -startIndex - 1

            for (i in startIndex until sortedTargetDates.size) {
                val target = sortedTargetDates[i]
                if (target > endDate) break
                statsMap[target]?.let { it.inProgressCount++ }
            }
        }
    }

    return sortedTargetDates.map { statsMap[it]!! }
}
